import React, { Component } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ActiveInactiveStatusBadge, ActiveInactiveStatusCombo, StyledCard } from '../../Base/Common/CommonUIComponents';
import { CustomTable } from '../../Base/Common/CustomTable';
import { getAPI } from '../../Base/API';
import { handleNotification } from '../../Base/Common/Notification';
import CancellationReasonModal from './CancellationReasonModal';
import Authorization, { CheckAuthorization } from '../../Base/Authorization';

class CancellationReasons extends Component {
    static displayName = CancellationReasons.name;

    constructor(props) {
        super(props);
        this.state = {
            block: false,
            error: [],
            cancellationReasons: [],
            modal: false,
            selectedReason: null,
            filterActive: null,
        };
    }

    componentDidMount() {
        this.getCancellationReasons();
    }

    getCancellationReasons = () => {
        const { filterActive } = this.state;
        this.setState({ block: true });

        const params = filterActive !== null ? `?active=${filterActive}` : '';

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                this.setState({ cancellationReasons: data.response || [], block: false });
            }
            else {
                this.setState({ block: false });
            }
        }, `/api/Voucher/v1/Config/cancellationReasons${params}`);
    }

    toggleModal = (reason) => {
        this.setState(prevState => ({
            modal: !prevState.modal,
            selectedReason: reason,
        }));
    }

    updateTable = (reason, isToRemove) => {
        const { cancellationReasons } = this.state;
        const index = cancellationReasons.findIndex(r => r.id === reason.id);
        let updatedReasons;

        if (isToRemove && index !== -1) {
            updatedReasons = cancellationReasons.filter((_, i) => i !== index);
        } else if (index !== -1) {
            updatedReasons = cancellationReasons.map((r, i) => i === index ? reason : r);
        } else {
            updatedReasons = [...cancellationReasons, reason];
        }

        this.setState({ cancellationReasons: updatedReasons, modal: false });
    }

    handleFilterChange = (name, combo) => {
        this.setState({ filterActive: combo ? combo.value : null });
    }

    render() {
        const { cancellationReasons, modal, filterActive } = this.state;

        const { intl } = this.props;

        const columns = [
            {
                dataField: 'name',
                text: intl.formatMessage({ id: "generic.Name" }),
            },
            {
                dataField: 'displayOrder',
                text: intl.formatMessage({ id: "CancellationReasons.DisplayOrder" }),
                headerStyle: { width: "25%" },
            },
            {
                dataField: 'active',
                text: intl.formatMessage({ id: "generic.status" }),
                formatter: (cell) => <ActiveInactiveStatusBadge status={cell} />,
                headerStyle: { width: "15%" },
            },
        ];

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,
            onSelect: (row) => {
                if (CheckAuthorization("cancellationReasons:manage")) {
                    this.toggleModal(row);
                }   
            },
        };

        return (
            <StyledCard icon="fa-solid fa-ban" block={this.state.block} error={this.state.error} title="navbar.CancellationReasons">
                {modal ?
                    <CancellationReasonModal
                        modal={modal}
                        toggleModal={this.toggleModal}
                        selectedReason={this.state.selectedReason}
                        updateTable={this.updateTable}
                    />
                    : ''}

                <Row className="mb-2 align-items-center">
                    <Col sm={3}>
                        <ActiveInactiveStatusCombo
                            name="filterActive"
                            onChangeFunc={this.handleFilterChange}
                            required={false}
                            value={filterActive}
                            isClearable
                            placeholder={<FormattedMessage id="generic.status" />}
                        />
                    </Col>
                    <Col className="text-right">
                        <Authorization 
                            perform="cancellationReasons:manage"
                            yes={() => (
                                <Button className="btn-sm btn-host" onClick={() => this.toggleModal(null)}>
                                    <i className="fa-solid fa-plus" />
                                </Button>
                            )}
                        />
                        
                        <Button className="btn-sm btn-host ml-2" onClick={() => this.getCancellationReasons()}>
                            <i className="fa-solid fa-search" />
                        </Button>
                    </Col>
                </Row>

                <CustomTable
                    data={cancellationReasons || []}
                    columns={columns}
                    shadow={false}
                    exportCSV={false}
                    showTotal={true}
                    remote={false}
                    selectRow={selectRow}
                />
            </StyledCard>
        );
    }
}

export default injectIntl(CancellationReasons);